import { render, staticRenderFns } from "./BadgeCard.vue?vue&type=template&id=131edbfb&scoped=true"
import script from "./BadgeCard.vue?vue&type=script&lang=js"
export * from "./BadgeCard.vue?vue&type=script&lang=js"
import style0 from "./BadgeCard.vue?vue&type=style&index=0&id=131edbfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131edbfb",
  null
  
)

export default component.exports